import { PpiAgreement } from 'models/PpiAgreement';
import { Action } from 'redux';

export const PPI_AGREEMENT_CHECK = 'PPI_AGREEMENT_CHECK';

export type AgreementCheckParam = Pick<PpiAgreement, 'id' | 'checked'>;
export type AgreementCheckAction = AgreementCheckParam & Action;
export const agreementCheck = (args: AgreementCheckParam) => ({
  type: PPI_AGREEMENT_CHECK,
  ...args
});
